/** @jsxImportSource @emotion/react */
'use memo'

import { ROUTES } from '@sportninja/common/constants/app'
import PlayerSuspensionsList from 'src/components/PlayerSuspensionsList'
import PlayerHighlights from '../../Player/PlayerHighlights'
import { PlayerHighlight } from '../../Player/types'
import PlayerStatsBySeason from '../../Profile/v2/PlayerStatsBySeason'
import { sortByDate } from '../helpers/profileFormatting'
import { ProfilePageConfig, ProfilePlayer, ProfileSuspension } from '../types'

const LegacyPlayerStatsBySeason = PlayerStatsBySeason as any
const LegacyPlayerHighlights = PlayerHighlights as any

interface UseProfilePagesParams {
  showStats: boolean
  selfPlayerIds: Array<string | number>
  players: ProfilePlayer[]
  highlights: PlayerHighlight[]
  suspensionLoading: boolean
  suspensions: ProfileSuspension[] | undefined
  setShowStats: (value: boolean) => void
}

export const useProfilePages = ({
  showStats,
  selfPlayerIds,
  players,
  highlights,
  suspensionLoading,
  suspensions,
  setShowStats,
}: UseProfilePagesParams): ProfilePageConfig[] => {
  return [
    showStats
      ? {
          text: 'Stats',
          to: ROUTES.PROFILE.ROOT,
          component: (
            <LegacyPlayerStatsBySeason
              playerIds={selfPlayerIds}
              setShowStats={setShowStats}
              players={players as any}
            />
          ),
        }
      : null,
    highlights.length > 0
      ? {
          text: 'Highlights',
          to: ROUTES.PROFILE.HIGHLIGHTS,
          component: <LegacyPlayerHighlights highlights={highlights} />,
        }
      : null,
    {
      text: 'Suspensions',
      to: ROUTES.PROFILE.SUSPENSIONS,
      component: (
        <PlayerSuspensionsList
          isProfileView
          loading={suspensionLoading}
          error={null}
          suspensions={sortByDate(suspensions) as any}
        />
      ),
    },
  ].filter(Boolean) as ProfilePageConfig[]
}
